import { computed, ref } from 'vue'
import { defineStore } from 'pinia'

import { isMenuGroup } from '@/components/classroom/sideMenu/types'
import type { ClassroomMenuContent, MenuMaterial, MenuNode } from '@/components/classroom/sideMenu/types'
import { mockCourse, mockTrail } from '@/components/classroom/sideMenu/mock'

const findInProgress = (nodes: MenuNode[]): string | undefined => {
  for (const node of nodes) {
    if (isMenuGroup(node)) {
      const nested = findInProgress(node.children)
      if (nested) return nested
    } else if (node.status === 'in-progress') {
      return node.id
    }
  }

  return undefined
}

const findFirstMaterial = (nodes: MenuNode[]): MenuMaterial | undefined => {
  for (const node of nodes) {
    if (isMenuGroup(node)) {
      const nested = findFirstMaterial(node.children)
      if (nested) return nested
    } else {
      return node
    }
  }

  return undefined
}

export const useClassRoomStore = defineStore('classRoom', () => {
  const menu = ref<ClassroomMenuContent>(mockTrail)
  const activeItemId = ref(findInProgress(mockTrail.children) || '')

  const contentKind = computed(() => menu.value.kind)
  const overallProgress = computed(() => menu.value.progress)

  const selectItem = (itemId: string) => {
    activeItemId.value = itemId
  }

  const setContent = (content: ClassroomMenuContent) => {
    menu.value = content
    activeItemId.value = findInProgress(content.children) || findFirstMaterial(content.children)?.id || ''
  }

  const setContentKind = (kind: ClassroomMenuContent['kind']) => {
    setContent(kind === 'trail' ? mockTrail : mockCourse)
  }

  return {
    menu,
    activeItemId,
    contentKind,
    overallProgress,
    selectItem,
    setContent,
    setContentKind
  }
})
